var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "invoice-wrapper", attrs: { id: "page_container" } },
    [
      _c(
        "div",
        { staticClass: "page" },
        [
          _c(
            "div",
            { staticClass: "main-container", attrs: { id: "main-container" } },
            [
              _c("div", { staticClass: "invoice-item-wrappper" }, [
                _c("div", { staticClass: "invoice-item" }, [
                  _c("div", { staticClass: "title" }, [_vm._v("发票类型")]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "content arrow",
                      on: { click: _vm.onShowInvoiceType }
                    },
                    [_vm._v(_vm._s(_vm.invoice.invoiceTypeStr))]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "invoice-item typeItem" },
                  [
                    _c("div", { staticClass: "title" }, [_vm._v("抬头类型")]),
                    _vm._v(" "),
                    _c(
                      "van-radio-group",
                      {
                        staticClass: "content radio",
                        on: { change: _vm.onTypeChange },
                        model: {
                          value: _vm.invoice.radio,
                          callback: function($$v) {
                            _vm.$set(_vm.invoice, "radio", $$v)
                          },
                          expression: "invoice.radio"
                        }
                      },
                      [
                        _c(
                          "van-radio",
                          { staticClass: "firstRadio", attrs: { name: "1" } },
                          [_vm._v("个人")]
                        ),
                        _vm._v(" "),
                        _c("van-radio", { attrs: { name: "2" } }, [
                          _vm._v("企业")
                        ])
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "invoice-item" },
                  [
                    _c("div", { staticClass: "title" }, [_vm._v("发票抬头")]),
                    _vm._v(" "),
                    _c(
                      "van-cell-group",
                      { staticClass: "content" },
                      [
                        _c("van-field", {
                          attrs: {
                            "input-align": "right",
                            placeholder: "发票抬头"
                          },
                          model: {
                            value: _vm.invoice.invoiceTitle,
                            callback: function($$v) {
                              _vm.$set(_vm.invoice, "invoiceTitle", $$v)
                            },
                            expression: "invoice.invoiceTitle"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "arrow chooseInvoice",
                      on: { click: _vm.onChooseInvoiceTitle }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.invoice.invoiceTitleType === "2"
                  ? _c(
                      "div",
                      { staticClass: "invoice-item" },
                      [
                        _c("div", { staticClass: "title" }, [_vm._v("税号")]),
                        _vm._v(" "),
                        _c(
                          "van-cell-group",
                          { staticClass: "content input" },
                          [
                            _c("van-field", {
                              attrs: {
                                "input-align": "right",
                                placeholder: "纳税人识别号"
                              },
                              model: {
                                value: _vm.invoice.taxNumber,
                                callback: function($$v) {
                                  _vm.$set(_vm.invoice, "taxNumber", $$v)
                                },
                                expression: "invoice.taxNumber"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.isShowCompany,
                        expression: "isShowCompany"
                      }
                    ]
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "invoice-item" },
                      [
                        _c("div", { staticClass: "title" }, [
                          _vm._v("开户银行")
                        ]),
                        _vm._v(" "),
                        _c(
                          "van-cell-group",
                          { staticClass: "content input" },
                          [
                            _c("van-field", {
                              attrs: {
                                "input-align": "right",
                                placeholder: "选填"
                              },
                              model: {
                                value: _vm.invoice.depositBank,
                                callback: function($$v) {
                                  _vm.$set(_vm.invoice, "depositBank", $$v)
                                },
                                expression: "invoice.depositBank"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "invoice-item" },
                      [
                        _c("div", { staticClass: "title" }, [
                          _vm._v("银行账号")
                        ]),
                        _vm._v(" "),
                        _c(
                          "van-cell-group",
                          { staticClass: "content input" },
                          [
                            _c("van-field", {
                              attrs: {
                                "input-align": "right",
                                placeholder: "选填"
                              },
                              model: {
                                value: _vm.invoice.bankAccount,
                                callback: function($$v) {
                                  _vm.$set(_vm.invoice, "bankAccount", $$v)
                                },
                                expression: "invoice.bankAccount"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "invoice-item" },
                      [
                        _c("div", { staticClass: "title" }, [
                          _vm._v("企业地址")
                        ]),
                        _vm._v(" "),
                        _c(
                          "van-cell-group",
                          { staticClass: "content input" },
                          [
                            _c("van-field", {
                              attrs: {
                                "input-align": "right",
                                placeholder: "选填"
                              },
                              model: {
                                value: _vm.invoice.enterpriseAddress,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.invoice,
                                    "enterpriseAddress",
                                    $$v
                                  )
                                },
                                expression: "invoice.enterpriseAddress"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "invoice-item" },
                      [
                        _c("div", { staticClass: "title" }, [
                          _vm._v("企业电话")
                        ]),
                        _vm._v(" "),
                        _c(
                          "van-cell-group",
                          { staticClass: "content input" },
                          [
                            _c("van-field", {
                              attrs: {
                                "input-align": "right",
                                placeholder: "选填"
                              },
                              model: {
                                value: _vm.invoice.enterprisePhone,
                                callback: function($$v) {
                                  _vm.$set(_vm.invoice, "enterprisePhone", $$v)
                                },
                                expression: "invoice.enterprisePhone"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.isShow,
                        expression: "isShow"
                      }
                    ],
                    staticClass: "pulldown"
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "enlarge", on: { click: _vm.onPullDown } },
                      [_c("i", { ref: "pulldown", staticClass: "icon" })]
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "submitBox" },
                [
                  _c(
                    "van-button",
                    {
                      attrs: { type: "primary", round: "", size: "large" },
                      on: { click: _vm.onSubmit }
                    },
                    [_vm._v("完成")]
                  ),
                  _vm._v(" "),
                  _c(
                    "van-button",
                    {
                      staticStyle: { "margin-top": "15px" },
                      attrs: { type: "default", round: "", size: "large" },
                      on: { click: _vm.onGoOrder }
                    },
                    [_vm._v("取消")]
                  )
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "van-popup",
            {
              attrs: { position: "bottom" },
              model: {
                value: _vm.showInvoiceType,
                callback: function($$v) {
                  _vm.showInvoiceType = $$v
                },
                expression: "showInvoiceType"
              }
            },
            [
              _c("van-picker", {
                attrs: {
                  columns: _vm.columns,
                  "show-toolbar": true,
                  title: "发票类型"
                },
                on: {
                  change: _vm.onInvoiceTypeChange,
                  confirm: _vm.onInvoiceTypeConfirm,
                  cancel: _vm.onInviceTypeCancel
                }
              })
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }